var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flag Pack",
    clipPath: "url(#clip0_1419_38447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6865 12.0974H-1.33635C-1.49324 12.0974 -1.62047 11.9702 -1.62047 11.8133V0.227126C-1.62047 0.0702343 -1.49324 -0.0569892 -1.33635 -0.0569892H16.6866C16.8435 -0.0569892 16.9707 0.0702342 16.9707 0.227126V11.8133C16.9707 11.9702 16.8434 12.0974 16.6865 12.0974Z",
    fill: "#41479B",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.893 4.44877H16.9707V7.59168H11.8931H11.7666L11.8724 7.66098L16.9707 11.0013V11.8133C16.9707 11.9702 16.8435 12.0974 16.6866 12.0974H15.258L9.305 8.19719L9.24658 8.15891V8.22875V12.0974H6.10368V8.22875V8.15891L6.04526 8.19719L0.0923055 12.0974H-1.33635C-1.49324 12.0974 -1.62047 11.9702 -1.62047 11.8133V11.0013L3.47789 7.66094L3.58367 7.59164H3.45721H-1.62047V4.44873H3.45721H3.58367L3.47789 4.37943L-1.62047 1.03911V0.227126C-1.62047 0.0702343 -1.49324 -0.0569892 -1.33635 -0.0569892H0.092268L6.04518 3.84323L6.1036 3.8815V3.81166V-0.0569892H9.24651V3.81166V3.8815L9.30493 3.84323L15.2579 -0.0569892H16.6865C16.8434 -0.0569892 16.9707 0.0702344 16.9707 0.227126V1.03911L11.8723 4.37947L11.7665 4.44877H11.893Z",
    fill: "#F5F5F5",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.60288 5.0547V5.09244H8.64061H16.9707V6.94797H8.64061H8.60288V6.98571V12.0974H6.74731V6.98571V6.94797H6.70957H-1.62047V5.09244H6.70957H6.74731V5.0547V-0.0569892H8.60288V5.0547Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.87671 7.66766H5.92041L-0.904591 12.0979H-1.33671C-1.47023 12.0979 -1.57873 12.0036 -1.6077 11.8768L4.87671 7.66766Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.7282 12.0898L9.91553 7.66762H10.9592L16.9706 11.5696V11.8138C16.9706 11.955 16.8655 12.0691 16.7282 12.0898Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M5.29479 4.37315H4.25114L-1.62047 0.561776V0.226986C-1.62047 0.120473 -1.56084 0.0285253 -1.47303 -0.0199969L5.29479 4.37315Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.9546 0.15435L10.4553 4.37326H9.41162L16.2365 -0.0569892H16.6864C16.8163 -0.0569892 16.9222 0.0325567 16.9546 0.15435Z",
    fill: "#FF4B55",
    stroke: "#3A3D5A",
    strokeWidth: 0.0754747
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1419_38447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.7bb0037654ed53190a494bab18156a7a.svg";
export { ForwardRef as ReactComponent };